import React from 'react'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { description, title } from '../../../constants/activity-seo'
import previewImg from '../../../assets/images/preview.png'
import SEO from '../../../shared/seo'

const fullUrlPreviewImg = siteUrl + previewImg
var onlyOnce = true
export default function AppSEO() {
  if (typeof window !== 'undefined') {
    if (!onlyOnce) {
      return null
    }
    onlyOnce = false
  }
  return (
    <>
      <SEO title={title} description={description} image={fullUrlPreviewImg} />
    </>
  )
}
